<template>
  <div class="lg:px-12 md:px-12 px-5 lg:py-8 md:py-10 py-8 bg-f3">
    <div class="container mx-auto">
      <div class="lg:w-2/3 mx-auto text-center">
        <h2 class="font-semibold text4F0A4B fsize32 md-fsize25 sm-fsize24 mb-2">
          Reference Websites and Partner Organizations
        </h2>
        <p class="lg:mb-4 md:mb-4 mb-2 sm-fsize14">
          Here are two lists of medically reviewed websites with a brief
          description for each, related to cancer information—one for India and
          another for global resources:
        </p>
      </div>
      <div class="mt-6">
        <p class="text-center font-semibold text4F0A4B fsize24 sm-fsize24 mb-2">
          FOR INDIA
        </p>
        <div class="lg:mt-6 md:mt-5 mt-4 lg:w-9/12 mx-auto">
          <swiper class="swiper" :options="swiperOptions">
            <swiper-slide v-for="(item, index) in indiaData" :key="index">
              <div class="bg-fff p-3 rounded-lg">
                <img
                  v-if="item.location === 'India' && item.picture"
                  :src="`${$imageURL}/${item.picture}`"
                  alt="india"
                  class="h-280px w-full object-cover rounded-lg"
                />
                <img
                  v-else
                  src="https://nimbus-server-01.brained.in/nimbus-server-01/default/images/default2.jpg"
                  alt="india"
                  class="h-280px w-full object-cover rounded-lg"
                />
                <div class="text-left">
                  <h2 class="uppercase clr-black fsize16 font-semibold pt-4">
                    {{ item.title }}
                  </h2>
                  <p class="fsize14 font-normal text-gray ellipsis-4 mt-1">
                    {{ item.description }}
                  </p>
                  <a :href="item.link" target="blank">
                    <div class="text-primary flex gap-1 items-center mt-2">
                      <p class="">Go to Website</p>
                      <feather-icon
                        icon="ArrowUpRightIcon"
                        class="cursor-pointer"
                        svgClasses="w-4 h-4"
                      ></feather-icon>
                    </div>
                  </a>
                </div>
              </div>
            </swiper-slide>

            <div
              class="swiper-button-prev adminswiper"
              slot="button-prev"
            ></div>
            <div
              class="swiper-button-next adminswiper"
              slot="button-next"
            ></div>
          </swiper>
        </div>
      </div>
      <div class="mt-10">
        <p class="text-center font-semibold text4F0A4B fsize24 sm-fsize24 mb-2">
          FOR GLOBAL
        </p>
        <div class="lg:mt-6 md:mt-5 mt-4 lg:w-11/12 mx-auto">
          <swiper class="swiper" :options="swiperOptions2">
            <swiper-slide v-for="(item, index) in globalData" :key="index">
              <div class="bg-fff p-3 rounded-lg">
                <img
                  v-if="item.location === 'Global' && item.picture"
                  :src="`${$imageURL}/${item.picture}`"
                  alt="india"
                  class="h-200 w-full object-cover rounded-lg"
                />
                <img
                  v-else
                  src="https://nimbus-server-01.brained.in/nimbus-server-01/default/images/default2.jpg"
                  alt="india"
                  class="h-200 w-full object-cover rounded-lg"
                />
                <div class="text-left">
                  <h2 class="uppercase clr-black fsize16 font-semibold pt-4">
                    {{ item.title }}
                  </h2>
                  <p class="fsize14 font-normal text-gray ellipsis-4 mt-1">
                    {{ item.description }}
                  </p>
                  <a :href="item.link" target="blank">
                    <div class="text-primary flex gap-1 items-center mt-2">
                      <p class="">Go to Website</p>
                      <feather-icon
                        icon="ArrowUpRightIcon"
                        class="cursor-pointer"
                        svgClasses="w-4 h-4"
                      ></feather-icon>
                    </div>
                  </a>
                </div>
              </div>
            </swiper-slide>

            <div
              class="swiper-button-prev adminswiper"
              slot="button-prev"
            ></div>
            <div
              class="swiper-button-next adminswiper"
              slot="button-next"
            ></div>
          </swiper>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { swiper, swiperSlide } from "vue-awesome-swiper";
import "swiper/dist/css/swiper.min.css";
import { mounted } from "@chenfengyuan/vue-countdown";
import { mapState } from "vuex/dist/vuex.common.js";
import router from "../../../routes/router";

export default {
  components: {
    swiper,
    swiperSlide,
  },
  data() {
    return {
      swiperOptions: {
        slidesPerView: 2,
        spaceBetween: 20,
        pagination: {
          el: ".swiper-pagination",
        },
        breakpoints: {
          1600: {
            slidesPerView: 2,
            spaceBetween: 20,
          },
          1300: {
            slidesPerView: 2,
            spaceBetween: 20,
          },
          900: {
            slidesPerView: 2,
            spaceBetween: 15,
          },
          640: {
            slidesPerView: 1,
            spaceBetween: 10,
          },
        },
        autoplay: {
          delay: 4000,
          disableOnInteraction: false,
        },
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev",
        },
      },
      swiperOptions2: {
        slidesPerView: 3,
        spaceBetween: 20,
        pagination: {
          el: ".swiper-pagination",
        },
        breakpoints: {
          1600: {
            slidesPerView: 3,
            spaceBetween: 20,
          },
          1300: {
            slidesPerView: 3,
            spaceBetween: 20,
          },
          900: {
            slidesPerView: 2,
            spaceBetween: 15,
          },
          768: {
            slidesPerView: 2,
            spaceBetween: 15,
          },
          640: {
            slidesPerView: 1,
            spaceBetween: 10,
          },
        },
        autoplay: {
          delay: 4000,
          disableOnInteraction: false,
        },
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev",
        },
      },
      indiaData: [],
      globalData: [],
      location: "",
    };
  },
  computed: {
    ...mapState("medicalCancer", ["AllMedicalCancer"]),
  },
  methods: {
    async goToWebsite(link) {
      router.push(link, "_blank");
    },
    //   async init() {
    //     let payload = {};
    //     if (this.$route.name === "medical_cancer") {
    //       payload.category = "Cancer";
    //     } else if (this.$route.name === "medical_palliative") {
    //       payload.category = "Palliative";
    //     }
    //     let data = await this.$store.dispatch("medicalCancer/getMedicalCancer");
    //     console.log(data, "7777777");
    //     console.log("123", this.AllMedicalCancer);
    //     this.indiaData = this.AllMedicalCancer.data.filter(
    //       (item) => item.category === "India"
    //     );
    //     this.globalData = this.AllMedicalCancer.data.filter(
    //       (item) => item.category === "Global"
    //     );
    //   },
    // },
    async init() {
      let payload = {};
      if (this.$route.name === "medical_cancer") {
        payload.category = "Cancer";
        this.location = "Global";
      } else if (this.$route.name === "medical_palliative") {
        payload.category = "Palliative";
        this.location = "Global";
      } else if (this.$route.name === "medical_dementia") {
        payload.category = "Dementia";
        this.location = "Global";
      } else if (
        this.$route.name === "medical_neurologicaldisorders" ||
        this.$route.name === "neurological_disorder"
      ) {
        payload.category = "Neurological Disorders";
        this.location = "Global";
      }

      // Fetch data from store
      let response = await this.$store.dispatch(
        "medicalCancer/getMedicalCancer",
        payload
      );
      const data = response.data.data;
      // console.log("payload data", response);
      // console.log("Data type:", typeof data);

      this.indiaData = data.filter((item) => item.location === "India");
      this.globalData = data.filter((item) => item.location === "Global");
      // console.log("payload data2", data);

      // Handle the data based on the category (Cancer or Palliative)
      if (payload.category === "Cancer") {
        this.globalData = this.globalData.filter(
          (item) => item.category === "Cancer"
        );
        this.indiaData = this.indiaData.filter(
          (item) => item.category === "Cancer"
        );
      } else if (payload.category === "Palliative") {
        this.globalData = this.globalData.filter(
          (item) => item.category === "Palliative"
        );
        this.indiaData = this.indiaData.filter(
          (item) => item.category === "Palliative"
        );
      } else if (payload.category === "Dementia") {
        this.globalData = this.globalData.filter(
          (item) => item.category === "Dementia"
        );
        this.indiaData = this.indiaData.filter(
          (item) => item.category === "Dementia"
        );
      } else if (payload.category === "Neurological Disorders") {
        this.globalData = this.globalData.filter(
          (item) => item.category === "Neurological Disorders"
        );
        this.indiaData = this.indiaData.filter(
          (item) => item.category === "Neurological Disorders"
        );
      }
    },
  },
  async mounted() {
    this.init();
    // console.log("AllMedicalCancer", this.AllMedicalCancer);
  },
};
</script>

<style></style>
